import { Component, OnInit, DoCheck } from '@angular/core';
import { EdpService } from '../services/edp.service';

type filtros = {
  periodo: string | null;
  nivel: string | null;
  carrera: string | null;
  matricula: string | null;
  tema1: 1 | null;
  tema2: 1 | null;
  tema3: 1 | null;
};

type carreras = {
  plan_estudio: string;
  carrera: string;
};

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.css'],
  standalone: false,
})
export class ReportesComponent implements OnInit, DoCheck {
  datos: filtros = {
    periodo: null,
    nivel: null,
    carrera: null,
    matricula: null,
    tema1: null,
    tema2: null,
    tema3: null,
  };

  carreras: carreras[] = [];
  selectedTemas: number[] = [];
  temas = [];

  consulta: string = '';

  isLoading: boolean = false;

  constructor(private service: EdpService) {}

  ngOnInit(): void {
    if (this.service.comprobarSesion()) {
      this.service.obtenerCarreras().subscribe(async (data: any) => {
        this.carreras = data;
      });

      this.service.obtenerTipoTema().subscribe(async (data: any) => {
        this.temas = await data;
      });
    }
  }

  ngDoCheck(): void {
    this.datos.tema1 = this.selectedTemas.includes(1) ? 1 : null;
    this.datos.tema2 = this.selectedTemas.includes(2) ? 1 : null;
    this.datos.tema3 = this.selectedTemas.includes(3) ? 1 : null;

    let carreraSelected = this.carreras.find(
      (carrera) => carrera.plan_estudio === this.datos.carrera
    )?.carrera;

    let nuevaConsulta = '';
    let temas = '';
    for (const [key, value] of Object.entries(this.datos)) {
      if (value) {
        if (nuevaConsulta && !key.includes('tema')) nuevaConsulta += ', ';

        if (key === 'nivel') {
          nuevaConsulta += `${key.toUpperCase()}: ${
            value === 'nb' ? 'Bachillerato' : 'Licenciatura'
          }`;
          continue;
        }

        if (key === 'carrera') {
          nuevaConsulta += `${key.toUpperCase()}: ${carreraSelected}`;
          continue;
        }

        if (key === 'tema1') {
          temas += 'Emocional';
          continue;
        }
        if (key === 'tema2') {
          if (temas) temas += ', ';
          temas += 'Académico';
          continue;
        }
        if (key === 'tema3') {
          if (temas) temas += ', ';
          temas += 'Vocacional';
          continue;
        }

        nuevaConsulta += `${key.toUpperCase()}: ${value}`;
      }
    }

    if (temas) {
      if (nuevaConsulta) nuevaConsulta += ', ';
      nuevaConsulta += `TIPO DE TEMA: ${temas}`;
    }

    this.consulta = nuevaConsulta;
  }

  onSubmit() {
    if (this.service.comprobarSesion()) {
      this.isLoading = true;

      this.service
        .generarReporte(sessionStorage.getItem('edpp-token'), this.datos)
        .subscribe({
          next: (res) => {
            const contentType = res.headers.get('Content-Type');

            if (contentType?.includes('application/json')) {
              const reader = new FileReader();
              reader.onload = () => {
                const errorJson = JSON.parse(reader.result as string);
                let error = errorJson?.[0]?.Error;
                if (error) {
                  alert(`Error: ${error}`);
                }
              };
              reader.readAsText(res.body as Blob);
            } else {
              let nombreArchivo = this.consulta
                ? `Reporte_${this.consulta
                    .replace(' - ', '-')
                    .replace(/:/g, '')
                    .replace(/, */g, '_')
                    .replace(/ /g, '-')
                    .toLowerCase()}`
                : `Reporte_todos`;
              this.downloadFile(res.body as Blob, `${nombreArchivo}.xlsx`);
            }
            this.isLoading = false;
          },
          error: (err) => {
            this.isLoading = false;
            console.error(err);
            alert('Ocurrió un error al contactar con el servidor');
          },
        });
    }
  }

  private downloadFile(data: Blob, filename: string): void {
    const link = document.createElement('a');
    const url = window.URL.createObjectURL(data);
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
  }
}
